import * as React from 'react';
import SVGIcon from '../SVGIcon';

const InfoIcon: React.FC = () => {
  return (
    <SVGIcon viewBox="0 0 17 16" width="17" height="16" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.25 2C11.5637 2 14.25 4.68629 14.25 8C14.25 11.3137 11.5637 14 8.25 14C4.93629 14 2.25 11.3137 2.25 8C2.25 4.68629 4.93629 2 8.25 2ZM8.25 7C7.73716 7 7.31449 7.38604 7.25673 7.88338L7.25 8V11C7.25 11.5523 7.69772 12 8.25 12C8.76284 12 9.18551 11.614 9.24327 11.1166L9.25 11V8C9.25 7.44772 8.80228 7 8.25 7ZM7.25 4L9.25 4V6H7.25V4Z"
        fill="#187A90"
      />
    </SVGIcon>
  );
};

export default InfoIcon;
